import { FC } from 'react';
import { Row, Col } from 'antd';
// import cs from 'classnames';
import styles from './index.module.less';

/**
 * @Description 未关联机会点时的机会点模块
 */
const UncorrelatedChancePoint: FC<{
  /** 别名 */
  chancepointAlias,
  /** 创建机会点 */
  createChancePoint,
  /** 关联机会点 */
  relativeChancePoint,
  /** 是否展示机会点操作 */
  ableToChangepoint: boolean,
  /** 是否禁用（分享时禁用操作） */
  disabled?: boolean;
}> = ({
  chancepointAlias, // 别名
  createChancePoint, // 创建机会点
  relativeChancePoint, // 关联机会点
  ableToChangepoint = true, // 是否展示机会点操作
  disabled,
}) => {

  return (
    <>
      <div className={styles.recordPointInfoWrap}>
        <div className={styles.infoTitle}>记录点位信息<span className={styles.subTitle}>可记录工程、房东、租金、周边等信息</span></div>
        {!disabled && ableToChangepoint ? <div className={styles.createPointWrap}>
          <Row gutter={12}>
            <Col span={12}>
              <div
                className={styles.createPointItem}
                onClick={createChancePoint}
              >
                <div className={styles.pointItemTitle}>新建{chancepointAlias}</div>
                <div className={styles.pointItemSubTitle}>新创建一条{chancepointAlias}</div>
                <img className={styles.pointItemIcon} src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/flow/create_icon@2x.png`} />
              </div>
            </Col>
            <Col span={12}>
              <div className={styles.createPointItem} onClick={relativeChancePoint}>
                {/* 参照这里的交互（不能直接复用），是新接口
                  src/common/components/business/ExpandStore/TaskDeatil/components/CreatePointMatching.tsx */}
                <div className={styles.pointItemTitle}>关联{chancepointAlias}</div>
                <div className={styles.pointItemSubTitle}>关联已有的{chancepointAlias}</div>
                <img className={styles.pointItemIcon} src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/flow/relative_icon@2x.png`} />
              </div>
            </Col>
          </Row>
        </div> : <></>}
      </div>
    </>
  );
};

export default UncorrelatedChancePoint;
